import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    triggers: [],
    triggersLoading: false,
    rawEvents: [],
    rawEventsLoading: false
  },
  mutations: {
    setList(state, events) {
      state.list = events;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    },
    setTriggersLoading(state, loading) {
      state.triggersLoading = loading;
    },
    setTriggers(state, triggerEvents) {
      state.triggers = triggerEvents;
    },
    setRawEvents(state, events) {
      state.rawEvents = events;
    },
    setRawEventsLoading(state, loading) {
      state.rawEventsLoading = loading;
    }
  },
  actions: {
    async loadAll({ commit, dispatch, rootState }) {
      commit("setListLoading", true);

      let events = await api.get("events", {
        params: {
          dateRange: [
            rootState.settings.dateRange.from,
            rootState.settings.dateRange.to
          ]
        }
      });

      commit("setList", events.data);
      commit("setListLoading", false);
    },
    async loadAllRaw({ commit, dispatch, rootState }) {
      commit("setRawEventsLoading", true);

      let events = await api.get("events/raw", {
        params: {
          dateRange: [
            rootState.settings.debugDateRange.from,
            rootState.settings.debugDateRange.to
          ]
        }
      });

      commit("setRawEvents", events.data);
      commit("setRawEventsLoading", false);
    },
    async loadTriggers({ commit, rootState }) {
      commit("setTriggersLoading", true);

      let triggerEvents = await api.get("events", {
        params: {
          dateRange: [
            rootState.settings.dateRange.from,
            rootState.settings.dateRange.to
          ],
          type: "trigger"
        }
      });

      commit("setTriggers", triggerEvents.data);
      commit("setTriggersLoading", false);
    },
    async downloadAttachment({ commit }, event) {
      window.open(
        `https://api.flexi-comms.com/events/downloadAttachment?id=${event.id}&fileType=${event.fileType}`,
        "_blank"
      );
    },
    async updateHiddenImage({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("events/updateHiddenImage", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async archive({ dispatch }, id) {
      let returnData = {};
      await api
        .post("events/archive", { id: id })
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    },
    triggers(state) {
      // return state.triggers.slice(0, 10);
      return state.triggers;
    },
    triggersLoading(state) {
      return state.triggersLoading;
    },
    rawEvents(state) {
      return state.rawEvents;
    },
    rawEventsLoading(state) {
      return state.rawEventsLoading;
    }
  }
};
